<div class="section section-header">
  <div class="header">
    <div class="header_left-side">
      <div class="logo">
        <img src="./assets/logo2.gif"/>
        <!-- <img [src]="gifUrl" width=" "> -->
      </div>
      <div class="user">
        <div class="user_name">{{ user?.lastName }} {{ user?.firstName }} {{ user?.middleName }}</div>
        <div class="user_region">
          <span *ngIf="user" class="user_region_name">
            <ng-container *ngIf="user.roles | userRole: 'MioAdministrator'">
              Администратор системы
            </ng-container>
            <ng-container *ngIf="user.roles">
              <ng-container *ngFor="let name of userMioName">
                <span> {{ name }} </span>
              </ng-container>
            </ng-container>
          </span>
        </div>
      </div>
    </div>
    <div class="header_center">
      ПОРТАЛ ОБЪЕКТОВ ПРОЕКТНОГО ФИНАНСИРОВАНИЯ
    </div>
    <div class="header_right-side">
      <div class="settings" (click)="settings()">
        <img src="./assets/svg-icons/settings.svg">
      </div>
      <div class="logout" (click)="logout()">
        <img src="./assets/svg-icons/exit.svg">
      </div>
    </div>
  </div>
</div>

<div class="section section-tab">
  <div class="wrapper">
    <div class="tabs" *ngIf="user">
      <div class="tab" (click)="goBack()"><img src="./assets/svg-icons/go-back-left-arrow.svg"></div>

      <div [ngClass]="homeBtn === true ? 'activeBtn' : ''" class="tab active" (click)="goHome()"
           *ngIf="curators || guest">
        <!-- <img src="./assets/images/icons/home.svg" /> -->
        Все объекты
      </div>

      <div [ngClass]="notRealBtn === true ? 'activeBtn' : ''" class="tab active" (click)="goHomeNotReal()"
           *ngIf="curators || guest">
        <!-- <img src="./assets/images/icons/home.svg" /> -->
        Строящиеся объекты
      </div>
      <div [ngClass]="realBtn === true ? 'activeBtn' : ''" class="tab active" (click)="goHomeReal()"
           *ngIf="curators || guest">
        <!-- <img src="./assets/images/icons/home.svg" /> -->
        Введенные объекты
      </div>
      <div [ngClass]="activeLocal === true ? 'activeBtn' : ''" class="tab active" (click)="addObject()"><img
        src="./assets/images/icons/add.svg"/>
        <span>Создать объект</span></div>
      <!-- <div class="tab active" *ngIf="curators" (click)="division(1)"><span>Обьекты МИО</span></div>
      <div class="tab active" *ngIf="curators"  (click)="division(2)"><span>Обьекты БД</span></div> -->
      <!-- <div class="tab active" (click)="videoInstructionModal = true"><span>Видеоинструкции</span></div> -->
      <div class="tab active" (click)="openMapModal()" *ngIf="curators || guest"><img
        src="./assets/images/icons/location.svg"/> <span>Область</span></div>

      <!-- <a class="tab" target="_blank" href="http://baiterekdevelopment.kz/ru/deyatelnost-kompanii/vykup-obligacij-mio-po-nұrly-zher/">Инструкции
        по выпуску облигаций МИО</a> -->
      <!-- <div class="tab" [ngClass]="activeLocalForMio === true ? 'activeBtn' : ''" [routerLink]="['/main', 'news']"
        (click)="forMio()">Для МИО
        <div *ngIf="!user?.roles | userRole: 'MioAdministrator' && newsFlag" class="news-count">{{countIsChecked}}</div>
      </div> -->
    </div>
  </div>
</div>


<app-modal-window *ngIf="settingsModal" [title]="'Настройки'" [visible]="settingsModal" [scrollbar]="false"
                  (close)="settingsModal = $event"
                  [width]="900">
  <div class="settings-modal">

    <div class="left-side">

      <div class="item" (click)="selectItem(1)" [ngClass]="selectedItemIndex === 1 ? 'active' : ''">
        <div class="item-left">
          <div class="icon"><span class="icon-secure"></span></div>
          <div class="title"> Безопасность</div>
        </div>
        <div class="item-right">
          <span class="icon icon-arrow"></span>
          <span class="icon icon-arrow-white"></span>
        </div>
      </div>

      <div class="item" (click)="selectItem(2)" [ngClass]="selectedItemIndex === 2 ? 'active' : ''">
        <div class="item-left">
          <div class="icon black"><img class="icon-logo" src="./assets/logo2.gif"/></div>
          <div class="title"> О программе</div>
        </div>
        <div class="item-right">
          <span class="icon icon-arrow"></span>
          <span class="icon icon-arrow-white"></span>
        </div>
      </div>

    </div>
    <div class="right-side">
      <div class="right-side__inner">
        <ng-container *ngIf="selectedItemIndex === 1">
          <app-change-password></app-change-password>
        </ng-container>
        <ng-container *ngIf="selectedItemIndex === 2">
          <div class="about-container">
            <div class="flex-row">
              <div class="title">О ПРОГРАММЕ</div>
              <div class="title-2 bold">GENRO</div>
            </div>
            <div class="flex-row">
              <div class="title">ВЕРСИЯ</div>
              <div class="title-2">1.0.0 25 авг 2018</div>
            </div>
            <div class="flex-row">
              <div class="title">РАЗРАБОТЧИК</div>
              <div class="title-2">Институт Цифровой <br/> Техники и Технологий</div>
              <div class="link"><a href="http://idet.kz/" target="_blank">www.idet.kz</a></div>
            </div>
            <div class="flex-row">
              <div class="title">АВТОР</div>
              <div class="title-2">Ким Владислав <br/> Олегович</div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-modal-window>

<app-modal-window
  *ngIf="mapModal"
  [title]="'Выберите регион'"
  [visible]="mapModal"
  [scrollbar]="false"
  [width]="1100"
  (close)="mapModal = $event"
>
  <app-map [mapModal]="mapModal"></app-map>
</app-modal-window>


<app-modal-window *ngIf="videoInstructionModal" [title]="'Видеоинструкции'" [visible]="videoInstructionModal"
                  [scrollbar]="false" (close)="videoInstructionModal = $event"
                  [width]="1100">
  <app-videoinstruction></app-videoinstruction>
</app-modal-window>

